const formatter = (value, rate, code = "NGN", indicator) => {
  const usdFormatter = new Intl.NumberFormat(indicator, {
    style: "currency",
    currency: code,
  });
  return usdFormatter.format(value / 1);
};

export default formatter;